// extracted by mini-css-extract-plugin
export default {"scrollToTop":"ScrollToTopButton_scrollToTop__BHV7v","visible":"ScrollToTopButton_visible__jnysm"};